import React from "react";

import { ReactComponent as Logo } from "shared/Icons/logo.svg";
import { Icon } from "widgets";

import { LOGIN_ARIA_LABELS, LOGIN_COPY, LOGIN_FEATURES } from "./constants/loginContent";
import styles from "./Login.module.scss";

const LoginBrandPanel = () => (
  <div className={styles.brandPanel}>
    <div className={styles.brandContent}>
      <Logo className={styles.brandLogo} aria-label={LOGIN_ARIA_LABELS.LOGO} />

      <h1 className={styles.welcomeTitle}>
        {LOGIN_COPY.WELCOME_PREFIX}{" "}
        <span className={styles.brandHighlight}>{LOGIN_COPY.BRAND_NAME}</span>
      </h1>
      <p className={styles.welcomeSubtitle}>{LOGIN_COPY.PLATFORM_SUBTITLE}</p>

      <ul className={styles.featureList}>
        {LOGIN_FEATURES.map((feature) => (
          <li key={feature.id} className={styles.featureItem}>
            <div className={styles.featureIcon} data-variant={feature.id}>
              <Icon name={feature.icon} fontSize="small" />
            </div>
            <div className={styles.featureText}>
              <span className={styles.featureTitle}>{feature.title}</span>
              <span className={styles.featureDesc}>{feature.description}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default LoginBrandPanel;
